import Router from './Component/RouteComponent/Router/Router';
import './App.css';

function App() {
    return (
        <>
            <Router />
        </>
    );
}

export default App;
